class FaqTopicSelector extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.faq-topics__nav-toggle');
    this.addEventListener('click', this.#handleClick);
    document.addEventListener('click', this.#handleOutsideClick);
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    document.removeEventListener('click', this.#handleOutsideClick);
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  get open() {
    return this.classList.contains('is-open');
  }

  set open(value) {
    this.classList.toggle('is-open', value);
    if (this.toggleButton) {
      this.toggleButton.setAttribute('aria-expanded', value ? 'true' : 'false');
    }
  }

  #handleClick = (event) => {
    if (event.target.closest('.faq-topics__nav-toggle')) {
      event.preventDefault();
      this.open = !this.open;
      return;
    }

    // Topic links: blog.url renders as an absolute URL on the store's canonical
    // domain, so a plain click navigates off the domain the user is currently on
    // (e.g. to the primary/prod domain). Force navigation onto the current origin
    // so the ?view=accordion page opens within the same store the user is viewing.
    const link = event.target.closest('.faq-topics__overlay-link');
    if (link && link.getAttribute('href')) {
      event.preventDefault();
      const url = new URL(link.getAttribute('href'), window.location.href);
      url.protocol = window.location.protocol;
      url.host = window.location.host;
      window.location.assign(url.toString());
    }
  };

  #handleOutsideClick = (event) => {
    if (this.open && !this.contains(event.target)) {
      this.open = false;
    }
  };

  #handleKeydown = (event) => {
    if (event.key === 'Escape' && this.open) {
      this.open = false;
      this.toggleButton?.focus();
    }
  };
}

if (!customElements.get('faq-topic-selector')) {
  customElements.define('faq-topic-selector', FaqTopicSelector);
}
